import { Component, Input, OnInit } from '@angular/core';
import { GameAssessmentViewModel } from 'src/app/load/models/EventModels';
import { MatCard, MatCardHeader, MatCardAvatar, MatCardTitle, MatCardSubtitle, MatCardContent, MatCardActions } from '@angular/material/card';
import { MatIcon } from '@angular/material/icon';
import { MatLabel } from '@angular/material/form-field';


@Component({
    selector: 'app-game-assessment-card',
    templateUrl: './game-assessment-card.component.html',
    styleUrls: ['./game-assessment-card.component.css'],
    imports: [MatCard, MatCardHeader, MatCardAvatar, MatIcon, MatCardTitle, MatLabel, MatCardSubtitle, MatCardContent, MatCardActions]
})
export class GameAssessmentCardComponent implements OnInit {

  @Input() GameAssessment: GameAssessmentViewModel;

  constructor() { }

  ngOnInit(): void {
  }

}
